import React from 'react'
import block from 'bem-cn'
import { shallowEqual, useSelector } from 'react-redux'

import { selectLocaleDict } from 'features/locale/selectors'

import { ReactComponent as HeartSVG } from 'shared/img/slots/heart-143.svg'

import './EmptyFavorites.scss'

const b = block('empty-favorites')

export const EmptyFavorites: React.FC = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).slots

  return (
    <article className={b()}>
      <h3 className={b('title')}>{locale.yourFavoritesList}</h3>
      <div className={b('description')}>
        <span>{locale.addFavoritesSlots}</span>
        <span className={b('icon-wrapper')}>
          <HeartSVG />
        </span>
      </div>
    </article>
  )
}
